import React from 'react'
import {
  Container,
  ContainerTitle,
  LoadingContainer,
  ContentInLine,
  SkeletonItem,
  SkeletonTitle,
  Title,
  Divider,
  Table,
  Td,
  Th,
  Tbody
} from './styles'
import { IconName } from '~/assets/icons'
import { NewbornScreeningTestProperty } from '~/interfaces'
import { IconComponent } from '~/assets/icons/component'

export interface IDynamicTableProps {
  headers: string[]
  content?: NewbornScreeningTestProperty[]
  icon?: IconName
  title: string
  loading?: boolean
}

export const DynamicTable: React.FC<IDynamicTableProps> = ({ headers, content, icon, title, loading = false }) => {
  const renderHeaders = () => {
    return (
      <thead>
        <tr>
          {headers.map(_header => (
            <Th key={`title-${_header}`}>{_header}</Th>
          ))}
        </tr>
      </thead>
    )
  }

  const renderContent = () => {
    return (
      <Tbody>
        {content?.map((_item, index) => (
          <tr key={`line-${index}`}>
            {headers.map((_header, _ind) => (
              <Td key={`column-${_ind}`}>{_item[Object.keys(_item)[_ind]] || ''}</Td>
            ))}
          </tr>
        ))}
      </Tbody>
    )
  }

  const Loader = (): JSX.Element => {
    return (
      <LoadingContainer>
        <SkeletonTitle width={'35%'} height={'20px'} />
        <SkeletonItem width={'100%'} height={'2px'} />
        <ContentInLine>
          <SkeletonItem width={'60px'} height={'20px'} />
          <SkeletonItem width={'60px'} height={'20px'} />
          <SkeletonItem width={'60px'} height={'20px'} />
          <SkeletonItem width={'60px'} height={'20px'} />
        </ContentInLine>
        <SkeletonItem width={'100%'} height={'20px'} />
        <SkeletonItem width={'100%'} height={'20px'} />
      </LoadingContainer>
    )
  }

  const renderTable = () => {
    if (loading) return Loader()
    if (!content?.length) return <></>
    return (
      <Container>
        <ContainerTitle>
          {icon && <IconComponent name={icon} />}
          <Title>{title}</Title>
        </ContainerTitle>
        <Divider />
        <Table>
          {renderHeaders()}
          {renderContent()}
        </Table>
      </Container>
    )
  }

  return renderTable()
}
